import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Señal desacoplada para refrescar el listado (POST /viajes → IndexedDB).
 * Evita dependencia circular OrderService ↔ CacheWarmupService.
 */
@Injectable({ providedIn: 'root' })
export class OrdersListRefreshService {
  private readonly requested$ = new Subject<void>();

  readonly refreshRequested$ = this.requested$.asObservable();

  requestListRefresh(): void {
    this.requested$.next();
  }
}
